import Tr from 'translations/Translations';

export const ContractorVerificationProcedureType = {
    CLASSIC: "CLASSIC",
    REVERSE: "REVERSE"
}
const _TR_PREFIX = 'contractor_verification_';
export const ContractorVerificationProcedureTypeLabel = (type) => (Tr(_TR_PREFIX + type.toLowerCase()));
